import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useLang } from "../../../Hooks";
import { ReportHeader } from "../Shared/Components/ReportHeader";
import { ReportToolbar } from "../Shared/Components/ReportToolbar";
import { reportToolbarStyles } from "../Shared/Styles/reportToolbarStyles";
import { useBalanceSheetAnalysisData } from "./hooks/useBalanceSheetAnalysisData";
import { BalanceSheetAnalysisActions } from "./Components/BalanceSheetAnalysisActions";
import { BalanceSheetAnalysisFilters } from "./Components/BalanceSheetAnalysisFilters";
import { BalanceSheetAnalysisTable } from "./Components/BalanceSheetAnalysisTable";

export default function BalanceSheetAnalysis() {
  const { texts } = useLang();
  const {
    applyFilters,
    changeCurrency,
    exportReport,
    filters,
    isExporting,
    isLoadingReport,
    reportData,
    toggleRow,
  } = useBalanceSheetAnalysisData();

  return (
    <Box p={2}>
      <Flex {...reportToolbarStyles.headerRow}>
        <ReportHeader
          title={texts.reports?.balanceSheetAnalysis || "Balance Sheet Analysis"}
          subtitle={texts.reports?.financialOverview || "Financial overview"}
        />
        <ReportToolbar>
          <BalanceSheetAnalysisFilters
            currentFilters={filters}
            onApplyFilters={applyFilters}
            onCurrencyChange={changeCurrency}
          />
          <BalanceSheetAnalysisActions isExporting={isExporting} onExport={exportReport} />
        </ReportToolbar>
      </Flex>
      <BalanceSheetAnalysisTable data={reportData} isLoading={isLoadingReport} onToggleRow={toggleRow} />
    </Box>
  );
}
